import { Minus, TrendingDown, TrendingUp, Zap } from 'lucide-react';
import { confidenceTone, formatLabel, sentimentTone } from './semantics';

interface SentimentBadgeProps {
  sentiment?: string;
  confidence?: string;
}

function SentimentIcon({ sentiment }: { sentiment: string }) {
  const norm = sentiment.toLowerCase();
  if (norm === 'positive') return <TrendingUp className="h-3 w-3" aria-hidden="true" />;
  if (norm === 'negative') return <TrendingDown className="h-3 w-3" aria-hidden="true" />;
  return <Minus className="h-3 w-3" aria-hidden="true" />;
}

export function SentimentBadge({ sentiment, confidence }: SentimentBadgeProps) {
  if (!sentiment && !confidence) return null;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {sentiment && (
        <span
          className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${sentimentTone(sentiment).pill}`}
          aria-label={`Sentiment: ${sentiment}`}
        >
          <SentimentIcon sentiment={sentiment} />
          {formatLabel(sentiment)}
        </span>
      )}
      {confidence && (
        <span
          className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${confidenceTone(confidence).pill}`}
          aria-label={`Extraction confidence: ${confidence}`}
        >
          <Zap className="h-3 w-3" aria-hidden="true" />
          {formatLabel(confidence)} confidence
        </span>
      )}
    </div>
  );
}
